export const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};
